'use client'

import { useEffect } from 'react'

import { useCheckAuth } from '@/features/auth/check'

import { getCookie } from '@/shared/lib/utils/common/getCookie'

import { useGetUserDataQuery } from '../api/userApiSlice'

export const useUser = () => {
	const { isAuthorized } = useCheckAuth()
	const authToken = getCookie('ACCESS_TOKEN')
	const { data, isLoading, isFetching, refetch, isError, isSuccess } = useGetUserDataQuery(undefined, {
		skip: !authToken,
		refetchOnMountOrArgChange: true
	})

	// Эффект для повторного запроса при изменении isAuthorized
	useEffect(() => {
		if (authToken) {
			refetch()
		}
	}, [authToken])

	return {
		user: data?.data,
		isLoading,
		isFetching,
		isAuthorized,
		isError,
		isSuccess
	}
}
